/**
 * @generated SignedSource<<7ee7466519c7d35c59f819e29f670159>>
 * @relayHash 6d22545c12674c5f64ce480bf0e39655
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e6448dd5f450d68e88b5308f3e6569a4736e837c8cb8b869311113f2e47d7740

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraBatchWindowPreference = "DEFAULT_BATCHING" | "FIFTEEN_MINUTES" | "FIVE_MINUTES" | "NO_BATCHING" | "ONCE_PER_DAY" | "ONE_DAY" | "ONE_HOUR" | "TEN_MINUTES" | "THIRTY_MINUTES" | "%future added value";
export type JiraEmailMimeType = "HTML" | "TEXT" | "%future added value";
export type JiraUpdateNotificationOptionsInput = {
  batchWindow?: JiraBatchWindowPreference | null | undefined;
  dailyBatchLocalTime?: string | null | undefined;
  emailMimeType?: JiraEmailMimeType | null | undefined;
  isEmailNotificationEnabled?: boolean | null | undefined;
  notifyOwnChangesEnabled?: boolean | null | undefined;
  notifyWhenRoleAssigneeEnabled?: boolean | null | undefined;
  notifyWhenRoleReporterEnabled?: boolean | null | undefined;
};
export type emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceFieldMutation$variables = {
  cloudId: string;
  input: JiraUpdateNotificationOptionsInput;
};
export type emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceFieldMutation$data = {
  readonly jira: {
    readonly updateGlobalNotificationOptions: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly options: {
        readonly " $fragmentSpreads": FragmentRefs<"emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceField">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceFieldMutation = {
  response: emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceFieldMutation$data;
  variables: emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceFieldMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceFieldMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateNotificationOptionsPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationOptions",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationOptions",
                "kind": "LinkedField",
                "name": "options",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceField"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceFieldMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateNotificationOptionsPayload",
            "kind": "LinkedField",
            "name": "updateGlobalNotificationOptions",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraNotificationOptions",
                "kind": "LinkedField",
                "name": "options",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isEmailNotificationEnabled"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e6448dd5f450d68e88b5308f3e6569a4736e837c8cb8b869311113f2e47d7740",
    "metadata": {},
    "name": "emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceFieldMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "852b87f7a5afd54294d7dfeb99fbd827";

export default node;
